import { Account } from '../../models/account';
import { UserDetails } from '../../models/users-models/user-details';
import { Auth0User } from '../../models/auth0User';
import { GdprConsent } from '../../components/global/consent/consent.service';
import { EntityState } from '@ngrx/entity';
import { LocationData } from '../../models/location-data';
import { locationDataAdapter } from './core-adapters';

export interface LocationDataState extends EntityState<LocationData> {
}

export interface CoreState {
  user: Auth0User, // auth0 user object
  userDetails: UserDetails, // additional user data
  googleMapsApiLoaded: boolean, // safe to initialize gmaps component
  accounts: Account[], // accounts which the logged-in user has access to
  selectedAccount: Account, // active account
  gdprConsent: GdprConsent,
  managedLocationCount: number | null, // total number of locations for the selected account
  lastManagedLocationCountRefreshTimestamp: number | null, // timestamp when count was last refreshed
  locationData: LocationDataState; // used to derive filter dropdown values in /campaigns, /reviews
  locationDataLoading: boolean;
}

export const initialState: CoreState = {
  user: null,
  userDetails: null,
  googleMapsApiLoaded: false,
  accounts: [],
  selectedAccount: null,
  gdprConsent: null,
  managedLocationCount: null,
  lastManagedLocationCountRefreshTimestamp: null,
  locationData: locationDataAdapter.getInitialState(),
  locationDataLoading: false,
};
